// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import flagMO from '../../../assets/img/flagsCountry/flag-MO.png'; // @ts-ignore

import flagMK from '../../../assets/img/flagsCountry/flag-MK.png'; // @ts-ignore

import flagMG from '../../../assets/img/flagsCountry/flag-MG.png'; // @ts-ignore

import flagMW from '../../../assets/img/flagsCountry/flag-MW.png'; // @ts-ignore

import flagMY from '../../../assets/img/flagsCountry/flag-MY.png'; // @ts-ignore

import flagMV from '../../../assets/img/flagsCountry/flag-MV.png'; // @ts-ignore

import flagML from '../../../assets/img/flagsCountry/flag-ML.png'; // @ts-ignore

import flagMT from '../../../assets/img/flagsCountry/flag-MT.png'; // @ts-ignore

import flagMH from '../../../assets/img/flagsCountry/flag-MH.png'; // @ts-ignore

import flagMQ from '../../../assets/img/flagsCountry/flag-MQ.png'; // @ts-ignore

import flagMR from '../../../assets/img/flagsCountry/flag-MR.png'; // @ts-ignore

import flagMU from '../../../assets/img/flagsCountry/flag-MU.png'; // @ts-ignore

import flagYT from '../../../assets/img/flagsCountry/flag-YT.png'; // @ts-ignore

import flagMX from '../../../assets/img/flagsCountry/flag-MX.png'; // @ts-ignore

import flagFM from '../../../assets/img/flagsCountry/flag-FM.png'; // @ts-ignore

import flagMD from '../../../assets/img/flagsCountry/flag-MD.png'; // @ts-ignore

import flagMC from '../../../assets/img/flagsCountry/flag-MC.png'; // @ts-ignore

import flagMN from '../../../assets/img/flagsCountry/flag-MN.png'; // @ts-ignore

import flagME from '../../../assets/img/flagsCountry/flag-ME.png'; // @ts-ignore

import flagMS from '../../../assets/img/flagsCountry/flag-MS.png'; // @ts-ignore

import flagMA from '../../../assets/img/flagsCountry/flag-MA.png'; // @ts-ignore

import flagMZ from '../../../assets/img/flagsCountry/flag-MZ.png'; // @ts-ignore

import flagMM from '../../../assets/img/flagsCountry/flag-MM.png'; // @ts-ignore

import flagNA from '../../../assets/img/flagsCountry/flag-NA.png'; // @ts-ignore

import flagNR from '../../../assets/img/flagsCountry/flag-NR.png'; // @ts-ignore

import flagNP from '../../../assets/img/flagsCountry/flag-NP.png'; // @ts-ignore

import flagNL from '../../../assets/img/flagsCountry/flag-NL.png'; // @ts-ignore

import flagNC from '../../../assets/img/flagsCountry/flag-NC.png'; // @ts-ignore

import flagNZ from '../../../assets/img/flagsCountry/flag-NZ.png'; // @ts-ignore

import flagNI from '../../../assets/img/flagsCountry/flag-NI.png'; // @ts-ignore

import flagNE from '../../../assets/img/flagsCountry/flag-NE.png'; // @ts-ignore

import flagNG from '../../../assets/img/flagsCountry/flag-NG.png'; // @ts-ignore

import flagNU from '../../../assets/img/flagsCountry/flag-NU.png'; // @ts-ignore

import flagNF from '../../../assets/img/flagsCountry/flag-NF.png'; // @ts-ignore

import flagMP from '../../../assets/img/flagsCountry/flag-MP.png'; // @ts-ignore

import flagNO from '../../../assets/img/flagsCountry/flag-NO.png'; // @ts-ignore

import flagOM from '../../../assets/img/flagsCountry/flag-OM.png'; // @ts-ignore

import flagPK from '../../../assets/img/flagsCountry/flag-PK.png'; // @ts-ignore

import flagPW from '../../../assets/img/flagsCountry/flag-PW.png'; // @ts-ignore

import flagPS from '../../../assets/img/flagsCountry/flag-PS.png'; // @ts-ignore

import flagPA from '../../../assets/img/flagsCountry/flag-PA.png'; // @ts-ignore

import flagPG from '../../../assets/img/flagsCountry/flag-PG.png'; // @ts-ignore

import flagPY from '../../../assets/img/flagsCountry/flag-PY.png'; // @ts-ignore

import flagPE from '../../../assets/img/flagsCountry/flag-PE.png'; // @ts-ignore

import flagPH from '../../../assets/img/flagsCountry/flag-PH.png'; // @ts-ignore

import flagPL from '../../../assets/img/flagsCountry/flag-PL.png'; // @ts-ignore

import flagPT from '../../../assets/img/flagsCountry/flag-PT.png'; // @ts-ignore

import flagPR from '../../../assets/img/flagsCountry/flag-PR.png'; // @ts-ignore

import flagQA from '../../../assets/img/flagsCountry/flag-QA.png'; // @ts-ignore

import flagRO from '../../../assets/img/flagsCountry/flag-RO.png'; // @ts-ignore

import flagRU from '../../../assets/img/flagsCountry/flag-RU.png'; // @ts-ignore

import flagRW from '../../../assets/img/flagsCountry/flag-RW.png'; // @ts-ignore

import flagBL from '../../../assets/img/flagsCountry/flag-BL.png'; // @ts-ignore

import flagSH from '../../../assets/img/flagsCountry/flag-SH.png'; // @ts-ignore

import flagKN from '../../../assets/img/flagsCountry/flag-KN.png'; // @ts-ignore

import flagLC from '../../../assets/img/flagsCountry/flag-LC.png'; // @ts-ignore

import flagMF from '../../../assets/img/flagsCountry/flag-MF.png'; // @ts-ignore

import flagPM from '../../../assets/img/flagsCountry/flag-PM.png'; // @ts-ignore

import flagVC from '../../../assets/img/flagsCountry/flag-VC.png'; // @ts-ignore

import flagWS from '../../../assets/img/flagsCountry/flag-WS.png'; // @ts-ignore

import flagSM from '../../../assets/img/flagsCountry/flag-SM.png'; // @ts-ignore

import flagST from '../../../assets/img/flagsCountry/flag-ST.png';
var CountriesC = [{
  ru: 'Macao',
  lt: 'Makao',
  tr: 'Macao',
  en: 'Macao',
  flagIcon: '🇲🇴',
  code: 'MO',
  flag: flagMO,
  dialCode: '853',
  mask: '9999 9999'
}, {
  ru: 'Македония',
  lt: 'Makedonija',
  tr: 'Makedonya',
  en: 'Macedonia',
  flagIcon: '🇲🇰',
  code: 'MK',
  flag: flagMK,
  dialCode: '389',
  mask: '999 999 999'
}, {
  ru: 'Мадагаскар',
  lt: 'Madagaskaras',
  tr: 'Madagaskar',
  en: 'Madagascar',
  flagIcon: '🇲🇬',
  code: 'MG',
  flag: flagMG,
  dialCode: '261',
  mask: '999 99 999 99'
}, {
  ru: 'Малави',
  lt: 'Malavis',
  tr: 'Malawi',
  en: 'Malawi',
  flagIcon: '🇲🇼',
  code: 'MW',
  flag: flagMW,
  dialCode: '265',
  mask: '9999 99 99 99'
}, {
  ru: 'Малайзия',
  lt: 'Malaizija',
  tr: 'Malezya',
  en: 'Malaysia',
  flagIcon: '🇲🇾',
  code: 'MY',
  flag: flagMY,
  dialCode: '60',
  mask: '999-999 9999'
}, {
  ru: 'Мальдивы',
  lt: 'Maldyvai',
  tr: 'Maldivler',
  en: 'Maldives',
  flagIcon: '🇲🇻',
  code: 'MV',
  flag: flagMV,
  dialCode: '960',
  mask: '999-9999'
}, {
  ru: 'Мали',
  lt: 'Malis',
  tr: 'Mali',
  en: 'Mali',
  flagIcon: '🇲🇱',
  code: 'ML',
  flag: flagML,
  dialCode: '223',
  mask: '99 99 99 99'
}, {
  ru: 'Мальта',
  lt: 'Malta',
  tr: 'Malta',
  en: 'Malta',
  flagIcon: '🇲🇹',
  code: 'MT',
  flag: flagMT,
  dialCode: '356',
  mask: '9999 9999'
}, {
  ru: 'Маршалловы острова',
  lt: 'Maršalo salos',
  tr: 'Marşal Adaları',
  en: 'Marshall Islands',
  flagIcon: '🇲🇭',
  code: 'MH',
  flag: flagMH,
  dialCode: '692',
  mask: '999-9999'
}, {
  ru: 'Мартиника',
  lt: 'Martinika',
  tr: 'Martinik',
  en: 'Martinique',
  flagIcon: '🇲🇶',
  code: 'MQ',
  flag: flagMQ,
  dialCode: '596',
  mask: '9999 99 99 99'
}, {
  ru: 'Мавритания',
  lt: 'Mauritanija',
  tr: 'Moritanya',
  en: 'Mauritania',
  flagIcon: '🇲🇷',
  code: 'MR',
  flag: flagMR,
  dialCode: '222',
  mask: '99 99 99 99'
}, {
  ru: 'Маврикий',
  lt: 'Mauricijus',
  tr: 'Mauritius',
  en: 'Mauritius',
  flagIcon: '🇲🇺',
  code: 'MU',
  flag: flagMU,
  dialCode: '230',
  mask: '9999 9999'
}, {
  ru: 'Майотта',
  lt: 'Majotas',
  tr: 'Mayotte',
  en: 'Mayotte',
  flagIcon: '🇾🇹',
  code: 'YT',
  flag: flagYT,
  dialCode: '262',
  mask: '9999 99 99 99'
}, {
  ru: 'Мексика',
  lt: 'Meksika',
  tr: 'Meksika',
  en: 'Mexico',
  flagIcon: '🇲🇽',
  code: 'MX',
  flag: flagMX,
  dialCode: '52',
  mask: '999 999 999 9999'
}, {
  ru: 'Микронезия, Федеративные Штаты Микронезии',
  lt: 'Mikronezijos Federacinės Mikronezijos valstybės',
  tr: 'Mikronezya, Mikronezya Federal Devletleri',
  en: 'Micronesia, Federated States of Micronesia',
  flagIcon: '🇫🇲',
  code: 'FM',
  flag: flagFM,
  dialCode: '691',
  mask: '999 9999'
}, {
  ru: 'Молдова',
  lt: 'Moldovoje',
  tr: 'Moldova',
  en: 'Moldova',
  flagIcon: '🇲🇩',
  code: 'MD',
  flag: flagMD,
  dialCode: '373',
  mask: '9999 99 999'
}, {
  ru: 'Монако',
  lt: 'Monakas',
  tr: 'Monako',
  en: 'Monaco',
  flagIcon: '🇲🇨',
  code: 'MC',
  flag: flagMC,
  dialCode: '377',
  mask: '99 99 99 99 99'
}, {
  ru: 'Монголия',
  lt: 'Mongolija',
  tr: 'Moğolistan',
  en: 'Mongolia',
  flagIcon: '🇲🇳',
  code: 'MN',
  flag: flagMN,
  dialCode: '976',
  mask: '9999 9999'
}, {
  ru: 'Черногория',
  lt: 'Juodkalnija',
  tr: 'Karadağ',
  en: 'Montenegro',
  flagIcon: '🇲🇪',
  code: 'ME',
  flag: flagME,
  dialCode: '382',
  mask: '999 999 999'
}, {
  ru: 'Монсеррат',
  lt: 'Montserratas',
  tr: 'Montserrat',
  en: 'Montserrat',
  flagIcon: '🇲🇸',
  code: 'MS',
  flag: flagMS,
  dialCode: '1664',
  mask: '(999) 999-9999'
}, {
  ru: 'Марокко',
  lt: 'Marokas',
  tr: 'Fas',
  en: 'Morocco',
  flagIcon: '🇲🇦',
  code: 'MA',
  flag: flagMA,
  dialCode: '212',
  mask: '9999-999999'
}, {
  ru: 'Мозамбик',
  lt: 'Mozambikas',
  tr: 'Mozambik',
  en: 'Mozambique',
  flagIcon: '🇲🇿',
  code: 'MZ',
  flag: flagMZ,
  dialCode: '258',
  mask: '99 999 9999'
}, {
  ru: 'Мьянма',
  lt: 'Mianmaras',
  tr: 'Myanmar',
  en: 'Myanmar',
  flagIcon: '🇲🇲',
  code: 'MM',
  flag: flagMM,
  dialCode: '95',
  mask: '99 999 9999'
}, {
  ru: 'Намибия',
  lt: 'Namibija',
  tr: 'Namibya',
  en: 'Namibia',
  flagIcon: '🇳🇦',
  code: 'NA',
  flag: flagNA,
  dialCode: '264',
  mask: '999 999 99999'
}, {
  ru: 'Науру',
  lt: 'Nauru',
  tr: 'Nauru',
  en: 'Nauru',
  flagIcon: '🇳🇷',
  code: 'NR',
  flag: flagNR,
  dialCode: '674',
  mask: '999 9999'
}, {
  ru: 'Непал',
  lt: 'Nepalas',
  tr: 'Nepal',
  en: 'Nepal',
  flagIcon: '🇳🇵',
  code: 'NP',
  flag: flagNP,
  dialCode: '977',
  mask: '999-9999999'
}, {
  ru: 'Нидерланды',
  lt: 'Nyderlandai',
  tr: 'Hollanda',
  en: 'Netherlands',
  flagIcon: '🇳🇱',
  code: 'NL',
  flag: flagNL,
  dialCode: '31',
  mask: '99'
}, {
  ru: 'Новая Каледония',
  lt: 'Naujoji Kaledonija',
  tr: 'Yeni Kaledonya',
  en: 'New Caledonia',
  flagIcon: '🇳🇨',
  code: 'NC',
  flag: flagNC,
  dialCode: '687',
  mask: '99.99.99'
}, {
  ru: 'Новая Зеландия',
  lt: 'Naujoji Zelandija',
  tr: 'Yeni Zelanda',
  en: 'New Zealand',
  flagIcon: '🇳🇿',
  code: 'NZ',
  flag: flagNZ,
  dialCode: '64',
  mask: '999 999 9999'
}, {
  ru: 'Никарагуа',
  lt: 'Nikaragva',
  tr: 'Nikaragua',
  en: 'Nicaragua',
  flagIcon: '🇳🇮',
  code: 'NI',
  flag: flagNI,
  dialCode: '505',
  mask: '9999 9999'
}, {
  ru: 'Нигер',
  lt: 'Nigeris',
  tr: 'Nijer',
  en: 'Niger',
  flagIcon: '🇳🇪',
  code: 'NE',
  flag: flagNE,
  dialCode: '227',
  mask: '99 99 99 99'
}, {
  ru: 'Нигерия',
  lt: 'Nigerija',
  tr: 'Nijerya',
  en: 'Nigeria',
  flagIcon: '🇳🇬',
  code: 'NG',
  flag: flagNG,
  dialCode: '234',
  mask: '9999 999 9999'
}, {
  ru: 'Niue',
  lt: 'Niue',
  tr: 'Niue',
  en: 'Niue',
  flagIcon: '🇳🇺',
  code: 'NU',
  flag: flagNU,
  dialCode: '683',
  mask: '999 9999'
}, {
  ru: 'Остров Норфолк',
  lt: 'Norfolko sala',
  tr: 'Norfolk Adası',
  en: 'Norfolk Island',
  flagIcon: '🇳🇫',
  code: 'NF',
  flag: flagNF,
  dialCode: '672',
  mask: '9 99999'
}, {
  ru: 'Северные Марианские острова',
  lt: 'Šiaurinės Marianos salos',
  tr: 'Kuzey Mariana Adaları',
  en: 'Northern Mariana Islands',
  flagIcon: '🇲🇵',
  code: 'MP',
  flag: flagMP,
  dialCode: '1670',
  mask: '(999) 999-9999'
}, {
  ru: 'Норвегия',
  lt: 'Norvegija',
  tr: 'Norveç',
  en: 'Norway',
  flagIcon: '🇳🇴',
  code: 'NO',
  flag: flagNO,
  dialCode: '47',
  mask: '999 99 999'
}, {
  ru: 'Оман',
  lt: 'Omanas',
  tr: 'Umman',
  en: 'Oman',
  flagIcon: '🇴🇲',
  code: 'OM',
  flag: flagOM,
  dialCode: '968',
  mask: '9999 9999'
}, {
  ru: 'Пакистан',
  lt: 'Pakistanas',
  tr: 'Pakistan',
  en: 'Pakistan',
  flagIcon: '🇵🇰',
  code: 'PK',
  flag: flagPK,
  dialCode: '92',
  mask: '9999 9999999'
}, {
  ru: 'Palau',
  lt: 'Palau',
  tr: 'Palau',
  en: 'Palau',
  flagIcon: '🇵🇼',
  code: 'PW',
  flag: flagPW,
  dialCode: '680',
  mask: '999 9999'
}, {
  ru: 'Палестинская территория, оккупированная',
  lt: 'Palestinos teritorija, okupuota',
  tr: 'Filistin Arazisi, İşgal altında',
  en: 'Palestinian Territory, Occupied',
  flagIcon: '🇵🇸',
  code: 'PS',
  flag: flagPS,
  dialCode: '970',
  mask: '9999 999 999'
}, {
  ru: 'Панама',
  lt: 'Panama',
  tr: 'Panama',
  en: 'Panama',
  flagIcon: '🇵🇦',
  code: 'PA',
  flag: flagPA,
  dialCode: '507',
  mask: '9999-9999'
}, {
  ru: 'Папуа - Новая Гвинея',
  lt: 'Papua Naujoji Gvinėja',
  tr: 'Papua Yeni Gine',
  en: 'Papua New Guinea',
  flagIcon: '🇵🇬',
  code: 'PG',
  flag: flagPG,
  dialCode: '675',
  mask: '9999 9999'
}, {
  ru: 'Парагвай',
  lt: 'Paragvajus',
  tr: 'Paraguay',
  en: 'Paraguay',
  flagIcon: '🇵🇾',
  code: 'PY',
  flag: flagPY,
  dialCode: '595',
  mask: '9999 999999'
}, {
  ru: 'Перу',
  lt: 'Peru',
  tr: 'Peru',
  en: 'Peru',
  flagIcon: '🇵🇪',
  code: 'PE',
  flag: flagPE,
  dialCode: '51',
  mask: '999 999 999'
}, {
  ru: 'Филиппины',
  lt: 'Filipinai',
  tr: 'Filipinler',
  en: 'Philippines',
  flagIcon: '🇵🇭',
  code: 'PH',
  flag: flagPH,
  dialCode: '63',
  mask: '9999 999 9999'
}, {
  ru: 'Польша',
  lt: 'Lenkija',
  tr: 'Polonya',
  en: 'Poland',
  flagIcon: '🇵🇱',
  code: 'PL',
  flag: flagPL,
  dialCode: '48',
  mask: '999 999 999'
}, {
  ru: 'Португалия',
  lt: 'Portugalija',
  tr: 'Portekiz',
  en: 'Portugal',
  flagIcon: '🇵🇹',
  code: 'PT',
  flag: flagPT,
  dialCode: '351',
  mask: '999 999 999'
}, {
  ru: 'Пуэрто-Рико',
  lt: 'Puerto Rikas',
  tr: 'Porto Riko',
  en: 'Puerto Rico',
  flagIcon: '🇵🇷',
  code: 'PR',
  flag: flagPR,
  dialCode: '1939',
  mask: '(999) 999-9999'
}, {
  ru: 'Катар',
  lt: 'Kataras',
  tr: 'Katar',
  en: 'Qatar',
  flagIcon: '🇶🇦',
  code: 'QA',
  flag: flagQA,
  dialCode: '974',
  mask: '9999 9999'
}, {
  ru: 'Румыния',
  lt: 'Rumunija',
  tr: 'Romanya',
  en: 'Romania',
  flagIcon: '🇷🇴',
  code: 'RO',
  flag: flagRO,
  dialCode: '40',
  mask: '9999 999 999'
}, {
  ru: 'Россия',
  lt: 'Rusija',
  tr: 'Rusya',
  en: 'Russia',
  flagIcon: '🇷🇺',
  code: 'RU',
  flag: flagRU,
  dialCode: '7',
  mask: '9 (999) 999-99-99'
}, {
  ru: 'Руанда',
  lt: 'Ruanda',
  tr: 'Ruanda',
  en: 'Rwanda',
  flagIcon: '🇷🇼',
  code: 'RW',
  flag: flagRW,
  dialCode: '250',
  mask: '9999 999 999'
}, {
  ru: 'Сен-Бартельми',
  lt: 'Šventasis Barthelemy',
  tr: 'Saint Barthelemy',
  en: 'Saint Barthelemy',
  flagIcon: '🇧🇱',
  code: 'BL',
  flag: flagBL,
  dialCode: '590',
  mask: '9999 99 99 99'
}, {
  ru: 'Святой Елены, Вознесения и Тристан-да-Кунья',
  lt: 'Šventoji Helena, Ascension ir Tristan Da Cunha',
  tr: 'Saint Helena, Yükseliş ve Tristan Da Cunha',
  en: 'Saint Helena, Ascension and Tristan Da Cunha',
  flagIcon: '🇸🇭',
  code: 'SH',
  flag: flagSH,
  dialCode: '290',
  mask: '99999'
}, {
  ru: 'Сент-Китс и Невис',
  lt: 'Sent Kitsas ir Nevis',
  tr: 'Saint Kitts ve Nevis',
  en: 'Saint Kitts and Nevis',
  flagIcon: '🇰🇳',
  code: 'KN',
  flag: flagKN,
  dialCode: '1869',
  mask: '(999) 999-9999'
}, {
  ru: 'Сент-Люсия',
  lt: 'Sent Lusija',
  tr: 'Saint Lucia',
  en: 'Saint Lucia',
  flagIcon: '🇱🇨',
  code: 'LC',
  flag: flagLC,
  dialCode: '1758',
  mask: '(999) 999-9999'
}, {
  ru: 'Святой мартин',
  lt: 'Sent Martinas',
  tr: 'Aziz Martin',
  en: 'Saint Martin',
  flagIcon: '🇲🇫',
  code: 'MF',
  flag: flagMF,
  dialCode: '590',
  mask: '9999 99 99 99'
}, {
  ru: 'Сен-Пьер и Микелон',
  lt: 'Sent Pjeras ir Mikelonas',
  tr: 'Saint Pierre ve Miquelon',
  en: 'Saint Pierre and Miquelon',
  flagIcon: '🇵🇲',
  code: 'PM',
  flag: flagPM,
  dialCode: '508',
  mask: '999 99 99'
}, {
  ru: 'Святой Винсент и Гренадины',
  lt: 'Sent Vinsentas ir Grenadinai',
  tr: 'Saint Vincent ve Grenadinler',
  en: 'Saint Vincent and the Grenadines',
  flagIcon: '🇻🇨',
  code: 'VC',
  flag: flagVC,
  dialCode: '1784',
  mask: '(999) 999-9999'
}, {
  ru: 'Самоа',
  lt: 'Samoa',
  tr: 'Samoa',
  en: 'Samoa',
  flagIcon: '🇼🇸',
  code: 'WS',
  flag: flagWS,
  dialCode: '685',
  mask: '99 99999'
}, {
  ru: 'Сан-Марино',
  lt: 'San Marinas',
  tr: 'San Marino',
  en: 'San Marino',
  flagIcon: '🇸🇲',
  code: 'SM',
  flag: flagSM,
  dialCode: '378',
  mask: '99 99 99 99'
}, {
  ru: 'Сан-Томе и Принсипи',
  lt: 'San Tomė ir Principe',
  tr: 'Sao Tome ve Principe',
  en: 'Sao Tome and Principe',
  flagIcon: '🇸🇹',
  code: 'ST',
  flag: flagST,
  dialCode: '239',
  mask: '999 9999'
}];
export default CountriesC;